import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ChangeOldPasswordVm } from '../../../shared/generated/Models/ChangeOldPassword/ViewModel/ChangeOldPasswordVm';

@Component({
    selector: 'pcg-change-old-password',
    templateUrl: './change-old-password.component.html',
    styleUrls: ['./change-old-password.component.scss'],
    standalone: false
})
export class ChangeOldPasswordComponent {
	//Form control
	formGroup = ChangeOldPasswordVm.Form;
	model = ChangeOldPasswordVm.GetModel(this.formGroup);

	constructor(private router: Router) {}

	messageSuccessReturn() {
		this.router.navigate(['/login']);
	}
}
